import { render, staticRenderFns } from "./OffersListComponent.vue?vue&type=template&id=496a2552&scoped=true"
import script from "./OffersListComponent.vue?vue&type=script&lang=js"
export * from "./OffersListComponent.vue?vue&type=script&lang=js"
import style0 from "./OffersListComponent.vue?vue&type=style&index=0&id=496a2552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "496a2552",
  null
  
)

export default component.exports